import React from 'react';
import _ from 'lodash';
import Moment from 'moment';
import T from 'i18n-react';

import HomeIcon from '@material-ui/icons/Home';

import { Logger } from '@apricityhealth/web-common-lib';
import { AxiosRequest } from '@apricityhealth/web-common-lib/utils/Axios';
import Config from '@apricityhealth/web-common-lib/Config';

import { ActionButton } from './ActionButton';

const log = new Logger();

export class HomeVisitButton extends React.Component {
    constructor(props) {
        super(props);
        this.state = { nextAppointment: null, visitNumber: 0 };
    }

    componentDidMount() {
        this.loadAppointments();
    }

    componentDidUpdate(oldProps) {
        const oldPatientId = _.get(oldProps.appContext, 'state.patientId');
        const newPatientId = _.get(this.props.appContext, 'state.patientId');
        if (oldPatientId !== newPatientId) this.loadAppointments();
    }

    loadAppointments() {
        const { appContext } = this.props;
        const { patientId, idToken } = appContext.state;
        if (!patientId || !idToken) return;

        const request = {
            url: Config.baseUrl + `${Config.pathPrefix}orgs/*/appointments?patientId=${patientId}&category=homeVisit&status=confirmed,requested,completed`,
            method: 'GET',
            headers: { Authorization: idToken }
        };
        AxiosRequest(request).then(({ data: { appointments } }) => {
            const list = (appointments || []).slice().sort((a, b) => new Date(a.start) - new Date(b.start));
            const now = new Date();
            const nextIdx = list.findIndex((a) => new Date(a.start) >= now);
            if (nextIdx < 0) {
                this.setState({ nextAppointment: null, visitNumber: 0 });
                appContext.setState({ daysUntilHomeVisit: undefined });
            } else {
                const nextAppointment = list[nextIdx];
                this.setState({ nextAppointment, visitNumber: nextIdx + 1 });
                const days = Math.max(0, Moment(nextAppointment.start).diff(Moment(), 'days'));
                appContext.setState({ daysUntilHomeVisit: days });
            }
        }).catch((err) => {
            log.error('HomeVisitButton getAppointments error:', err);
            this.setState({ nextAppointment: null, visitNumber: 0 });
            appContext.setState({ daysUntilHomeVisit: undefined });
        });
    }

    render() {
        const { appContext } = this.props;
        const { nextAppointment, visitNumber } = this.state;
        if (!nextAppointment) return null;

        const start = Moment(nextAppointment.start);
        const date = start.format('MMMM D, YYYY');
        const days = Math.max(0, start.diff(Moment(), 'days'));
        const desc = T.translate('homeVisit-desc-format', { date, days });
        const chip = T.translate('homeVisit-visit-chip', { visitNumber });

        return <ActionButton
            id='homeVisit'
            key='homeVisit'
            metric='homeVisit'
            appContext={appContext}
            to={`/appointments#appt-${nextAppointment.appointmentId}`}
            chevron={true}
            chip={chip}
            icon={<HomeIcon />}
            color='#0076bb'
            label={<T.span text='nextHomeVisit' />}
            label2={desc}
        />;
    }
}

export default HomeVisitButton;
